import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#383352', // Dark purple from the image
      light: '#5c5677',
      dark: '#28253a',
      contrastText: '#fff',
    },
    secondary: {
      main: '#f1eee4', // Light beige/cream from the image
      light: '#f7f5ef',
      dark: '#e5e1d6',
      contrastText: '#383352',
    },
    background: {
      default: '#f1eee4', // Light beige/cream
      paper: '#ffffff',
    },
    text: {
      primary: '#383352', // Dark purple
      secondary: '#656177',
    },
    action: {
      active: '#383352',
      hover: 'rgba(56, 51, 82, 0.08)',
    },
    divider: '#e0dbd0',
  },
  typography: {
    fontFamily: [
      'Inter',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
    h1: {
      fontWeight: 600,
      color: '#383352',
    },
    h2: {
      fontWeight: 600,
      color: '#383352',
    },
    h3: {
      fontWeight: 600,
      color: '#383352',
    },
    h4: {
      fontWeight: 600,
      color: '#383352',
    },
    h5: {
      fontWeight: 600,
      color: '#383352',
    },
    h6: {
      fontWeight: 600,
      color: '#383352',
    },
    subtitle1: {
      fontWeight: 500,
      color: '#383352',
    },
    subtitle2: {
      fontWeight: 500,
      color: '#383352',
    },
    body1: {
      color: '#383352',
    },
    body2: {
      color: '#656177',
    },
    button: {
      textTransform: 'none',
      fontWeight: 500,
    },
  },
  shape: {
    borderRadius: 4,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          textTransform: 'none',
          fontWeight: 500,
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        },
        contained: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 4,
            '& fieldset': {
              borderColor: '#e0dbd0',
            },
            '&:hover fieldset': {
              borderColor: '#c4c0b5',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#383352',
            },
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          border: '1px solid #e0dbd0',
        },
        elevation1: {
          boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.05)',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          border: '1px solid #e0dbd0',
          borderRadius: 4,
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          color: '#383352',
          fontWeight: 600,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 4,
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: '#383352',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff',
          color: '#383352',
          boxShadow: 'none',
          borderBottom: '1px solid #e0dbd0',
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#f1eee4',
          borderRight: '1px solid #e0dbd0',
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: 'rgba(56, 51, 82, 0.08)',
            '&:hover': {
              backgroundColor: 'rgba(56, 51, 82, 0.12)',
            },
          },
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: 'rgba(56, 51, 82, 0.08)',
            '&:hover': {
              backgroundColor: 'rgba(56, 51, 82, 0.12)',
            },
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          fontWeight: 600,
          backgroundColor: '#f7f5ef',
          color: '#383352',
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: 4,
        },
      },
    },
  },
});

export default theme;
